import config from "../config";

const VERIFY_GST_URL = `${config.apiUrl}/apifabric/common/validate-gst`;

const USER_TYPE = {
  FABRIC_CUSTOMER_ORG_ROLE: 4,
};

export const verifyGstApi = (gstNumber) => {
  return fetch(
    `${VERIFY_GST_URL}?gstNumber=${gstNumber}&skipDuplicateCheck=true`,
    {
      method: "GET",
      headers: {
        "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
      },
    },
  ).then(async (res) => {
    const data = await res.json(); 
    return data;
  });
};
